import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const adminService = {
  get_all_staff: async (search = "", page = 1, limit = 10, token) => {
    const params = new URLSearchParams({
      search_value: search,
      page: page,
      limit: limit,
    }).toString();

    const response = await https.get(
      `${API_ROUTES.ADMIN.GET_ALL_STAFF}?${params}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  get_staff_by_id: async (staff_id, token) => {
    const response = await https.get(
      `${API_ROUTES.ADMIN.GET_STAFF_BY_ID}/${staff_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  delete_staff: async (staff_id, token) => {
    const response = await https.delete(
      `${API_ROUTES.ADMIN.DELETE_STAFF}/${staff_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  create_user: (data, token) => {
    const uri = API_ROUTES.ADMIN.CREATE_STAFF;
    return https.post(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  update_user: (data, staff_id, token) => {
    const uri = `${API_ROUTES.ADMIN.UPDATE_INFO_STAFF}/${staff_id}`;
    return https.put(uri, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  get_staff_permission: async (token, staffId) => {
    const response = await https.get(
      `${API_ROUTES.ADMIN.GET_STAFF_PERMISSION.replace(":staffId", staffId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
  assign_permission: async (token, staffId, data) => {
    const response = await https.post(
      `${API_ROUTES.ADMIN.ASSIGN_PERMISSION.replace(":staffId", staffId)}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    return response;
  },
};
